import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = { class: "plan-details" }
const _hoisted_3 = {
  id: "email-change-form",
  class: "form account-settings pdt-25 gap-30 w-50 w-sm-100"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "w-100" }, " Change Email ", -1)
const _hoisted_5 = { class: "w-full d-flex gap-3 align-items-end flex-md-row flex-column" }
const _hoisted_6 = {
  key: 0,
  class: "w-full d-flex flex-column"
}
const _hoisted_7 = { class: "w-full d-flex gap-3 align-items-end flex-md-row flex-column" }
const _hoisted_8 = { class: "w-full d-flex gap-3 align-items-end pdt-20" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "divider divider_green mt-40 mb-40" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", { class: "w-100" }, " Forget Password ", -1)
const _hoisted_11 = { class: "w-full d-flex gap-3 flex-md-row flex-column" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "divider divider_green mt-40 mb-40" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "w-100" }, " Two-Factor Authentication (Required) ", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "action-buttons d-flex justify-content-between w-100 gap-20 mt-40 sm-pdl-0 sm-pdr-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_ProfileInfo = _resolveComponent("ProfileInfo")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      errors: _ctx.errors,
      success: _ctx.success
    }, null, 8, ["errors", "success"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ProfileInfo, {
              items: _ctx.items,
              multiple: true,
              classes: ""
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_TextInput, {
                type: "email",
                modelValue: _ctx.userEmail,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userEmail) = $event)),
                label: "Current Email Address",
                placeholder: _ctx.userEmail,
                readonly: true
              }, null, 8, ["modelValue", "placeholder"]),
              (!_ctx.updateSettingsState.email)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary lh-1 h-fit w-sm-100",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleUpdateSetting('email')))
                  }, " Update "))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.updateSettingsState.email)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_TextInput, {
                    type: "email",
                    modelValue: _ctx.newEmail,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newEmail) = $event)),
                    label: "New Email Address",
                    placeholder: "Enter New Email Address"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_TextInput, {
                    type: "email",
                    modelValue: _ctx.newEmailConfirmation,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newEmailConfirmation) = $event)),
                    label: "Confirm New Email Address",
                    placeholder: "Confirm New Email Address"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary lh-1 h-fit w-sm-100",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateEmail && _ctx.updateEmail(...args)))
                  }, " Update "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary lh-1 h-fit w-sm-100",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleUpdateSetting('email')))
                  }, " Discard ")
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_9,
          _createElementVNode("form", {
            id: "email-change-form",
            class: "form account-settings gap-30",
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateEmail && _ctx.updateEmail(...args)), ["prevent"]))
          }, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_TextInput, {
                type: "password",
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.password) = $event)),
                label: "Change Password",
                placeholder: "....."
              }, null, 8, ["modelValue"]),
              _createVNode(_component_TextInput, {
                type: "password",
                modelValue: _ctx.passwordConfirmation,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
                label: "Re-Enter New Password",
                placeholder: "....."
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary lh-1 h-fit w-sm-100",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args)))
            }, " Update Password ")
          ], 32),
          _hoisted_12,
          _createElementVNode("form", {
            id: "email-change-form",
            class: "form account-settings gap-30",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateEmail && _ctx.updateEmail(...args)), ["prevent"]))
          }, _hoisted_14, 32),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", {
              href: "",
              onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.impersonate && _ctx.impersonate(...args)), ["prevent"])),
              class: "btn btn-secondary w-sm-100"
            }, "Masquerade as this user"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary w-sm-100",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
            }, " Save ")
          ])
        ]))
  ], 64))
}